export const roundNumber = (value: number, digits: number): number => {
  return Number(value.toFixed(digits));
};
